export const STEPS = [
  "Start your learning journey",
  "Complete the assessment",
  "Get the certificate ",
];
